import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Link from 'components/Link';
import ScrollArrows from 'components/ScrollArrows';
import { sendMenuClickEvent } from 'utils/metrics';
import styles from './MenuBar.module.scss';

export function MenuBar({ menuBarItemsSections }) {
  const containerId = 'menu_bar_container';
  const leftButtonId = 'menu_bar_left_button';
  const rightButtonId = 'menu_bar_right_button';

  const router = useRouter();
  const [activeUrl, setActiveUrl] = useState();

  useEffect(() => {
    const { asPath } = router;
    if (asPath !== activeUrl) {
      setActiveUrl(asPath);
    }
  }, [router]);

  return (
    <section>
      <ScrollArrows
        useNoArrowCss
        containerId={containerId}
        leftButtonId={leftButtonId}
        rightButtonId={rightButtonId}
        scrollBuffer={5}
        scrollIncrement={125}
      >
        <div
          id={containerId}
          className={classNames('my-2 py-3', styles.menu_bar)}
        >
          {menuBarItemsSections
            ?.filter((section) => section.item?.title && section.item?.href)
            .map((section) => {
              const {
                item: { title, href },
              } = section;
              return (
                <Link
                  key={title}
                  className={classNames(
                    'fs-8 text-uppercase fw-600 px-7 px-lg-12 px-xl-15',
                    styles.menu_item,
                    { [styles.active_menu_item]: href === activeUrl }
                  )}
                  data-value={`menu-option-${title}`}
                  href={href}
                  onClick={() => {
                    const itemId = title.toLowerCase().replaceAll(' ', '_');
                    sendMenuClickEvent(`button_${itemId}`);
                  }}
                >
                  <span className="">{title}</span>
                </Link>
              );
            })}
        </div>
      </ScrollArrows>
    </section>
  );
}

export default MenuBar;
